
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class MigrationPointerModel extends Model<MigrationPointerModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'pointer', type: 'string' },
		{ name: 'migrationSiteId', type: 'string' }
	];
	[key: string]: any;
	
	public id?: string;
	public pointer: string;
	public migrationSiteId?: string;
    
	constructor(){
		super();
		this.id = undefined;
		this.pointer = '';
		this.migrationSiteId = undefined;
		
	}
	getProperties(){
		return MigrationPointerModel.classProperties;
	}
}

